module.exports = __webpack_public_path__ + "static/media/exclamation.b32d4566.svg";